import { Caption, Body1 } from "@coherehealth/common";
import { Box } from "@mui/material";
import { useClinicalReviewStyles } from "../caseCompletePageStyles";
import { CaseCompletePageT } from "../caseCompletePageUtils";

export const OutcomeSection = ({ serviceCase, cohereIds }: CaseCompletePageT) => {
  const classes = useClinicalReviewStyles();
  const shouldShowFaxSection = serviceCase?.faxDetail?.faxNumber;
  const shouldShowFaxDetailSection = serviceCase?.faxDetail?.cohereId;
  const shouldShowTrackingNumber = cohereIds && cohereIds.length > 0;
  return serviceCase ? (
    <>
      <Box className={classes.outcomeCaseTrackingBox}>
        <Caption className={classes.caption}>Outcome</Caption>
        <Body1 className={classes.body1}>{serviceCase?.outcome?.description ?? "Outcome not provided"}</Body1>
      </Box>
      {shouldShowFaxSection && (
        <Box className={classes.outcomeCaseTrackingBox}>
          <Caption className={classes.caption}>Fax from</Caption>
          <Body1 className={classes.body1}>{serviceCase?.faxDetail?.faxNumber}</Body1>
        </Box>
      )}
      {shouldShowFaxDetailSection && (
        <Box className={classes.outcomeCaseTrackingBox}>
          <Caption className={classes.caption}>Fax ID</Caption>
          <Body1 className={classes.body1}>{serviceCase?.faxDetail?.cohereId}</Body1>
        </Box>
      )}
      <Box className={classes.outcomeCaseTrackingBox}>
        <Caption className={classes.caption}>Case ID</Caption>
        <Body1 className={classes.body1}>{serviceCase?.caseNumber}</Body1>
      </Box>
      {shouldShowTrackingNumber && (
        <Box className={classes.outcomeCaseTrackingBox}>
          <Caption className={classes.caption}>Tracking #</Caption>
          <Body1 className={classes.body1}>
            {cohereIds.length < 4 ? cohereIds.join(", ") : cohereIds.slice(0, 3).join(", ") + "..."}
          </Body1>
        </Box>
      )}
    </>
  ) : null;
};
